import gql from 'graphql-tag';

export default gql`
  mutation ValidateAdminUser($id: ID!, $otp: String!, $firstName: String, $lastName: String, $password: String!) {
    validateUser(data: { id: $id, otp: $otp, firstName: $firstName, lastName: $lastName, password: $password }) {
      token
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/mutations/ValidateAdminUser.ts